import { requests } from "@/functional/api/api";
import type { ListedServicePlanModel } from "@/models/listedServicePlan.model";
import isOffline from "@/functional/isOffline";
import chainSleep from "@/functional/chainSleep";

let list: (
  organisationId: string,
  userId: string,
) => Promise<ListedServicePlanModel[]> = (organisationId, userId) =>
  requests.get<ListedServicePlanModel[]>(
    `Organisations/${organisationId}/users/${userId}/service-plans`,
  );

if (isOffline)
  list = (organisationId: string): Promise<ListedServicePlanModel[]> =>
    Promise.resolve<ListedServicePlanModel[]>([
      {
        publicId: "00000000-0000-0000-0000-000000000000",
        displayName: "Default",
        accessScheduledStart: "2020-01-01T00:00:00Z",
        accessScheduledEnd: "2030-01-01T00:00:00Z",
        serviceSuspendedAt: null,
        seatLimit: 10,
        organisationPublicId: organisationId,
        suiteCount: 2,
      },
      {
        publicId: "00000000-0000-0000-0000-000000000001",
        displayName: "TP",
        accessScheduledStart: "2025-01-01T00:00:00Z",
        accessScheduledEnd: "2027-01-01T00:00:00Z",
        serviceSuspendedAt: "2025-06-01T00:00:00Z",
        seatLimit: 5,
        organisationPublicId: organisationId,
        suiteCount: 2,
      },
    ]).then(chainSleep(100, 2000));

export interface UpdateServicePlanRequest {
  displayName: string;
  accessScheduledStart: string;
  accessScheduledEnd: string;
  shouldSuspendService: boolean;
  seatLimit: number;
  suiteSlugs: string[];
}

let update: (
  servicePlanId: string,
  request: UpdateServicePlanRequest,
) => Promise<void> = (servicePlanId, request) =>
  requests.put(`servicePlans/${servicePlanId}`, request);

if (isOffline) {
  update = () => Promise.resolve().then(chainSleep(100, 3000));
}

let get: (
  organisationId: string,
  userId: string,
  servicePlanId: string,
) => Promise<ListedServicePlanModel> = (
  organisationId,
  userId,
  servicePlanId,
) =>
  requests.get(
    `Organisations/${organisationId}/users/${userId}/service-plans/${servicePlanId}`,
  );

if (isOffline) {
  get = () =>
    Promise.resolve({
      publicId: "00000000-0000-0000-0000-000000000000",
      displayName: "Default",
      accessScheduledStart: "2020-01-01T00:00:00Z",
      accessScheduledEnd: "2030-01-01T00:00:00Z",
      serviceSuspendedAt: null,
      seatLimit: 10,
      organisationPublicId: "00000000-0000-0000-0000-000000000000",
      suiteCount: 2,
    }).then(chainSleep(100, 3000));
}

export interface CreateServicePlanRequest {
  orgPublicId: string;
  displayName: string;
  accessScheduledStart: string;
  accessScheduledEnd: string;
  seatLimit: number;
  suiteSlugs: string[];
}

let create: (
  request: CreateServicePlanRequest,
) => Promise<ListedServicePlanModel> = (request) =>
  requests.post(`servicePlans`, request);

if (isOffline) {
  create = (request: CreateServicePlanRequest) =>
    Promise.resolve({
      publicId: "00000000-0000-0000-0000-000000000000",
      displayName: "Default",
      accessScheduledStart: "2020-01-01T00:00:00Z",
      accessScheduledEnd: "2030-01-01T00:00:00Z",
      serviceSuspendedAt: null,
      seatLimit: 10,
      organisationPublicId: request.orgPublicId,
      suiteCount: 2,
    }).then(chainSleep(100, 3000));
}

export default {
  list,
  get,
  update,
  create,
};
